







































































































import store from '@/store';
import {
  LoadingService,
  ExtendMixins,
} from '@/services';
import { EventBus } from '@/event-bus';
import {
  OpenUpdateAddressScreen,
  OpenUpdateEmailScreen,
  OpenUpdatePhoneScreen,
  OpenUpdatePasswordScreen,
} from '@/mixins/get-content-mixins';
import { TokenReAuth } from '@/components/page-components';
import { ConstructPhoneNumber } from '@/helpers';
import { Address, MemberPersonalInformationResponseModel, UserModel, NonUSAddress } from '@/@types/member';

interface Data {
  tokenModal: boolean;
  tokenCallback: () => {};
}

export default ExtendMixins(
  OpenUpdateAddressScreen,
  OpenUpdateEmailScreen,
  OpenUpdatePhoneScreen,
  OpenUpdatePasswordScreen,
).extend({
  name: 'PersonalInformation',
  beforeRouteEnter(to, from, next) {
    LoadingService.watchPromises(store.dispatch('getPersonalInformation'))
      .then(next)
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          action: {
            label: 'global_try-again',
            performAction() {
              location.reload();
            },
          },
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  data() {
    return {
      tokenModal: false,
      tokenCallback() {},
    };
  },
  methods: {
    openTokenModal(callback): void {
      this.tokenModal = true;
      this.tokenCallback = callback;
    },
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },
    usAddress(): Address {
      return this.personalInformation.address;
    },
    nonUSAddress(): NonUSAddress {
      return this.personalInformation.nonUSAddress;
    },
    primaryPhone(): string {
      return ConstructPhoneNumber(this.personalInformation.primaryPhone);
    },
    alternatePhone(): string {
      return ConstructPhoneNumber(this.personalInformation.alternatePhone);
    },
    // MBR-51: BR-1.11
    isSuppressPassword(): boolean {
      return this.user.session.auth === 'sso';
    },
  },
  components: {
    TokenReAuth,
  },
});
